export class ExamesNaviosModel {
  id: number;
  nome: string;
  imo: string;
}



// WEBPACK FOOTER //
// ./src/app/exames/navios/exames-navios.model.ts